/**
 * 该provider依赖jquery模块，使用前确认是否已安装
 */


import { tools } from '../utils/tools.js'
import { element } from '../utils/element.js'
import { v4 as uuidv4 } from 'uuid';


import Muuri from "./widget-libs/muuri.min.js"

export default class Widget {
    constructor(proc) {
        this.proc = proc;
        this.Widgets = {};
        this.$root = proc.$root;
    }


    /**
     * 注册组件
     * @param {Object} options 
     */
    register(options = { icon: '', x: 1, y: 1, row: 1, col: 1, name: '', content: '', disable: false }) {
        

    }

    initGrid($container) {
        setTimeout(()=>{
            var grid = new Muuri(document.querySelector($container), {
                items: '.item1',
            });
        },1000)
    }

}